<div class="row">
    <div class="col-xs-12">
        <form #form='ngForm'>
        <fieldset [disabled]="formProcessingBlocked">

            <div class="row">
                <div class="col-xs-4">
                    <app-bluechat-carrier-delivery-list [deliveries]="_deliveries"
                                                        [displayListCarrierName]="canSubmitAllBluechatNotes"
                                                        [userBluechatConfig]="userBluechatConfig"
                                                        (deleteCarrier)="onCarrierDelete($event)">
                    </app-bluechat-carrier-delivery-list>
                </div>
                <div class="col-xs-8">
                    <div class="row">

                        <!-- processes -->
                        <div class="col-xs-12 m-b-md">
                            <div class="row">
                                <div class="col-xs-12">
                                    <span><span [i18n]="'bluechat.note-creation.process'"></span>*</span>
                                    <i class="fa fa-info-circle tooltip-container">
                                        <div class="tooltip" *ngIf="notCommonProcesses && notCommonProcesses.length > 0">
                                            <span [i18n]="'bluechat.note-creation.process-tooltip.non-common'"></span>
                                            <ul>
                                                <li *ngFor="let process of notCommonProcesses">
                                                    <span class="process">{{process.process.title}}</span>&nbsp;
                                                    <span *ngIf="process.blockingCarriers.length > 0"
                                                          [i18n]="[{target: 'innerHTML', key: 'bluechat.note-creation.process-tooltip.non-common-carriers', params: { carriers: process.blockingCarriers.join(', ') }}]"></span>
                                                    <span *ngIf="process.blockingCarriers.length === 0"
                                                          [i18n]="'bluechat.note-creation.process-tooltip.non-common-not-assigned'"></span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div *ngIf="!notCommonProcesses || notCommonProcesses.length === 0" class="tooltip">
                                            <span [i18n]="'bluechat.note-creation.process-tooltip.all-common'"></span>
                                        </div>
                                    </i>
                                    <ng-select [required]="true"
                                               name="process"
                                               [(ngModel)]="process"
                                               (ngModelChange)="onProcessChange($event)">
                                        <ng-option *ngFor="let process of processes"
                                                   [value]="process"
                                                   [disabled]="isProcessDisabled(process)">
                                            {{process.title}}
                                        </ng-option>
                                    </ng-select>
                                </div>
                            </div>
                        </div>

                        <!-- note types -->
                        <div class="col-xs-12 m-b-md">
                            <span><span [i18n]="'bluechat.note-creation.note-type'"></span>*</span>
                            <ng-select name="noteType"
                                       [disabled]="!selectedProcessNoteTypes"
                                       [class.ng-select-disabled]="!selectedProcessNoteTypes"
                                       [(ngModel)]="noteType"
                                       [required]="true"
                                       (ngModelChange)="onNoteTypeChange($event)">
                                <ng-option *ngFor="let noteType of selectedProcessNoteTypes" [value]="noteType">{{noteType}}</ng-option>
                            </ng-select>
                        </div>

                        <div class="col-xs-12 m-b-md">
                            <span [i18n]="'bluechat.note-creation.subject'"></span>
                            <span>
                                <input class="form-control"
                                       name="subject"
                                       type="text"
                                       [(ngModel)]="subject">
                            </span>
                            <small>
                                <span [i18n]="'bluechat.note-creation.preview.title'"></span>:
                                <span [i18n]="_deliveries?.length === 1 ?
                                        _deliveries[0].deliveryNumber :
                                        'bluechat.note-creation.preview.delivery-number'">
                                </span>
                                <span> - <span [i18n]="noteType ? noteType : 'bluechat.note-creation.preview.note-type'"></span></span>
                                <span>{{subject?.length > 0 ? ' - ' + subject : ''}}</span>
                            </small>
                        </div>

                        <div class="col-xs-12 m-b-md">
                            <div class="row">

                                <form #templateForm='ngForm'>
                                <!-- subject -->
                                <div class="col-xs-6">
                                    <span [i18n]="'bluechat.note-creation.template'"></span>
                                    <ng-select
                                        name="template"
                                        [(ngModel)]="template"
                                        [disabled]="!templates"
                                        (change)="onTemplateChange($event)">
                                        <ng-option *ngFor="let template of templates" [value]="template">{{template.name}}</ng-option>
                                    </ng-select>
                                </div>

                                <!-- priority -->
                                <div class="col-xs-6">
                                    <span [i18n]="'bluechat.note-creation.priority'"></span>
                                    <ng-select name="priority" [(ngModel)]="priority" [clearable]="false">
                                        <ng-option *ngFor="let priority of notePriority" [value]="priority">{{priority}}</ng-option>
                                    </ng-select>
                                </div>
                            </form>
                            </div>
                        </div>

                        <!-- Message Editor -->
                        <div class="col-xs-12 m-b-md">
                            <quill-editor
                                name="message"
                                theme="snow"
                                [required]="true"
                                [modules]="quillModules"
                                [(ngModel)]="message"
                                (onEditorCreated)="onEditorCreated($event)">
                            </quill-editor>
                        </div>

                        <div class="col-xs-12 m-b-md">
                            <!-- Attachments -->
                            <app-file-upload [acceptedFileTypes]="acceptedFileTypes"
                                             [maxFileSize]="maxFileSizePerAttachment"
                                             [labelKey]="'bluechat.note-creation.attachments'"
                                             (onFileAdded)="addToAttachments($event)">
                            </app-file-upload>

                            <div class="row">
                                <div class="col-xs-6">
                                    <small [i18n]="'bluechat.note-creation.expected-formats-label'"></small>
                                </div>
                                <div class="col-xs-6 text-right">
                                    <small [i18n]="[{target: 'innerHTML', key: 'bluechat.note-creation.limit-size', params: { maxSize: maxFileSizePerAttachment | fileSize }}]"></small>
                                </div>
                            </div>
                        </div>

                        <!-- Attachments Preview -->
                        <div class="col-xs-12 m-b-md">
                            <div class="attachment" *ngFor="let file of attachments; let index = index">
                                <i class="fas fa-paperclip"></i>
                                <strong>{{file.filename}}</strong>
                                <i (click)="removeAttachment(index)" class="fa fa-trash"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xs-12">
                    <button type="button" class="btn btn-lg pull-left btn-white" (click)="cancel()"
                            [i18n]="'buttons.cancel'">
                    </button>
                    <button [disabled]="form.invalid || anySelectedCarrierNotAssignToCurrentUser"
                            type="submit" class="btn btn-lg pull-right btn-primary submit-button" (click)="submit()"
                            [i18n]="'bluechat.note-creation.create-request'">
                    </button>
                </div>
            </div>
        </fieldset>
        </form>
    </div>
</div>


